/**
 * Политики свежести по эндпоинтам. Числа здесь не вкусовые — они следуют из того,
 * как ведёт себя бэкенд, поэтому у каждого есть обоснование.
 */

/**
 * ⚠️ НОЛЬ, и это несущее решение. `/auth/me` и `/subscription` несут `subscriptionDays`
 * и `emailStatus`, которые сервер перечитывает из БД на КАЖДОМ защищённом роуте
 * (server/modules/auth/auth.guards.ts): access-токен состояния не хранит и переживает
 * отзыв, а мгновенная реакция на оплату и на подтверждение почты держится именно на этом.
 * В PHP они точно так же читались на каждый запрос. Любой staleTime > 0 здесь означает
 * «человек оплатил, а кабинет ещё говорит, что подписки нет».
 */
export const IDENTITY_STALE_TIME_MS = 0;

/**
 * Тарифы меняются админом вручную и крайне редко. Пять минут убирают повторный запрос при
 * открытии модалки оплаты несколько раз подряд и при возврате на лендинг.
 *
 * ⚠️ Сервер отдаёт `/plans` с `Cache-Control: public, max-age=60`. Клиентский staleTime
 * больше серверного намеренно: HTTP-кеш общий и может быть сброшен прокси, а этот —
 * про одну вкладку, где повторный запрос за те же пять минут не даст ничего нового.
 */
export const PLANS_STALE_TIME_MS = 5 * 60_000;

/**
 * Пример задачи неизменен: он захардкожен ключом `1_3_1_8` (как и в PHP), а сам эндпоинт
 * отдаётся с `Cache-Control: public, max-age=300`. Совпадаем с сервером, а не спорим с ним.
 */
export const TASK_EXAMPLE_STALE_TIME_MS = 5 * 60_000;

/**
 * Решение задачи по конкретному ключу неизменно в пределах сессии, а повторный поиск
 * того же ключа СНОВА расходует дневной лимит на сервере (30 в сутки). Кэш здесь не
 * оптимизация, а защита кошелька пользователя от случайного двойного клика.
 */
export const TASK_LOOKUP_STALE_TIME_MS = Infinity;

/**
 * Юридические документы — статический контент репозитория. Сервер отдаёт их с ETag по
 * содержимому и `Cache-Control: public, max-age=31536000, immutable`, то есть внутри
 * жизни вкладки они измениться не могут в принципе: смена текста означает новую сборку
 * образа. Перезапрашивать нечего.
 */
export const LEGAL_DOCUMENT_STALE_TIME_MS = Infinity;

/**
 * Заявка на удаление аккаунта. НОЛЬ: заявку исполняет ночная задача, а отклонить её может
 * админ — то есть состояние меняется БЕЗ участия этой вкладки. Показать человеку заявку,
 * которую уже исполнили, значит предложить ему кнопку отзыва, которая ответит 404.
 */
export const ACCOUNT_DELETION_STALE_TIME_MS = 0;

/**
 * Админка. НОЛЬ по той же причине, по которой сервер отдаёт КАЖДЫЙ админский ответ
 * с `Cache-Control: no-store`: это рабочий инструмент, где человек правит данные и тут же
 * обязан увидеть результат — свой или чужой. Показать администратору кассу пятиминутной
 * давности значит дать ему свести её с выпиской и не понять расхождения.
 */
export const ADMIN_STALE_TIME_MS = 0;

/** Сколько неиспользуемые данные лежат в памяти до сборки. */
export const DEFAULT_GC_TIME_MS = 5 * 60_000;

/**
 * Ретраи: по умолчанию React Query повторяет три раза, что для нашего бэкенда вредно.
 * Повторять осмысленно только сеть и 5xx. Повтор 4xx бессмыслен (ответ не изменится),
 * а на 429 он прямо вреден: лимитеры считают КАЖДУЮ попытку, и авто-ретрай удлиняет
 * блокировку, которую пользователь пытается переждать.
 */
export function shouldRetry(failureCount: number, status: number): boolean {
  if (failureCount >= 2) return false;
  if (status === 0) return true;
  return status >= 500;
}
